export default "__VITE_ASSET__DqVocUkQ__"